import * as React from "react";
import clsx from "clsx";

import * as PropTypes from "../prop-types";
import { PropsType } from "../PropsType";
import { spsGlobalPropTypes } from "../util";

import { SpsSummaryListExpansion } from "./SpsSummaryListExpansion";

export const propTypes = {
    ...spsGlobalPropTypes,
    selected: PropTypes.bool
}

// Infers the correct types and adds any html props that are ok for the element type
export type SpsSummaryListRowProps = PropsType<typeof propTypes> & React.HTMLAttributes<HTMLDivElement>;

export function SpsSummaryListRow(props: SpsSummaryListRowProps) {
    const {
        children,
        className,
        "data-testid": testId,
        selected,
        unsafelyReplaceClassName,
        ...rest
    } = props;

    const [selectedRow, setSelected] = React.useState(false);
    const [isExpanded, setIsExpanded] = React.useState(false);
    const [expandable, setExpandable] = React.useState(false);

    let _eleRef: any = React.useRef();

    React.useEffect(() => {
        const isExpandable = React.Children.toArray(children).some(child => {
            return React.isValidElement(child) && child.type === SpsSummaryListExpansion
        });
        if (isExpandable) {
            setExpandable(true);
        }

        if (props.selected) {
            setSelectedRow();
        }
    }, []);

    React.useEffect(() => {
        setSelectedRow();
    }, [selected]);

    const setSelectedRow = () => {
        setSelected(props.selected);
    };

    const toggle = e => {
        e.stopPropagation();
        setIsExpanded(!isExpanded);
    };

    const classes = clsx(
        unsafelyReplaceClassName || "sps-summary-list-row",
        "sps-content-row",
        expandable && "sps-summary-list-row--expandable",
        isExpanded && "sps-content-row--expanded",
        selectedRow && "sps-summary-list-row--selected",
        className,
    );

    return (
        <div className={classes}
            {...rest}
            data-testid={`${testId}`}
            ref={_eleRef}>
            <div className="sps-content-row__col-group"
                data-testid={`${testId}__col-group`}
                onClick={toggle}>
                {React.Children.map(children, (child: any) => {
                    if (child || child.type !== SpsSummaryListExpansion) {
                        return child;
                    }
                })}
            </div>
            <React.Fragment>
                {
                    React.Children.map(children, (child: any) => {
                        if (child && child.type === SpsSummaryListExpansion) {
                            return child;
                        }
                    })}
            </React.Fragment>
        </div>
    );
}

Object.assign(SpsSummaryListRow, {
    propTypes,
    displayName: "SpsSummaryListRow"
});
